import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors duration-200 hover:bg-primary-600 md:h-11 md:w-11"
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}